import gql from "graphql-tag";

// fragment
export const GREENHOUSE_DEPARTMENT_FRAGMENT = gql`
    fragment greenhouseDepartment on GreenhouseDepartmentNode {
        id
        name
        description
        temperatureMin
        temperatureMax
        humidityMin
        humidityMax
        pesticide
        totalSpaceM2
        totalUsedSpaceM2
        totalUsedRate
        isPlaceholder
        layoutX
        layoutY
        width
        height
        order
        greenhouse {
            id
            name
        }
        greenhouseDepartmentSectionSet {
            edges {
                node {
                    id
                    name
                    spaceM2
                    usedSpaceM2
                    usedRate
                    numGrowthTasks
                    numPlants
                    order
                    isPlaceholder
                    layoutX
                    layoutY
                    width
                    height
                }
            }
        }
        updatedAt
        updatedBy
    }
`;

// all query
export const GREENHOUSE_DEPARTMENTS_QUERY = gql`
    query {
        greenhouseDepartments {
            edges {
                cursor
                node {
                    ...greenhouseDepartment
                }
            }
        }
    }
    ${GREENHOUSE_DEPARTMENT_FRAGMENT}
`;

// single query
export const SINGLE_GREENHOUSE_DEPARTMENT_QUERY = gql`
    query greenhouseDepartment($id: ID!) {
        greenhouseDepartment(id: $id) {
            ...greenhouseDepartment
        }
    }
    ${GREENHOUSE_DEPARTMENT_FRAGMENT}
`;

// create
export const CREATE_GREENHOUSE_DEPARTMENT_MUTATION = gql`
    mutation createGreenhouseDepartment(
        $input: CreateGreenhouseDepartmentInput!
    ) {
        createGreenhouseDepartment(input: $input) {
            greenhouseDepartment {
                ...greenhouseDepartment
            }
        }
    }
    ${GREENHOUSE_DEPARTMENT_FRAGMENT}
`;

// update
export const UPDATE_GREENHOUSE_DEPARTMENT_MUTATION = gql`
    mutation updateGreenhouseDepartment(
        $input: UpdateGreenhouseDepartmentInput!
    ) {
        updateGreenhouseDepartment(input: $input) {
            greenhouseDepartment {
                ...greenhouseDepartment
            }
        }
    }
    ${GREENHOUSE_DEPARTMENT_FRAGMENT}
`;

// delete
export const DELETE_GREENHOUSE_DEPARTMENT_MUTATION = gql`
    mutation deleteGreenhouseDepartment(
        $input: DeleteGreenhouseDepartmentInput!
    ) {
        deleteGreenhouseDepartment(input: $input) {
            greenhouseDepartment {
                ...greenhouseDepartment
            }
        }
    }
    ${GREENHOUSE_DEPARTMENT_FRAGMENT}
`;
